import { DateTime } from 'luxon'
import styles from './ChartHeader.module.css'
import { ExpandButton } from './ExpandButton'
import { CollapseButton } from './CollapseButton'

interface ChartHeaderProps{
    name: string
    date: any//DateTime[]
    expanded: boolean
    onExpandButtonClick: (event: any) => void
    onCollapseButtonClick: (event: any) => void
}

export const ChartHeader = (props: ChartHeaderProps): JSX.Element => {
    const {
        name = '',
        date,
        expanded,
        onExpandButtonClick,
        onCollapseButtonClick
    } = props

    const toDateFormat = (date: DateTime) => {
        return date.toFormat('M/dd/yyyy')
    }

    let dateString = ``
    if (date && date[0] !== undefined && date[1] !== undefined){
        dateString =  `(${toDateFormat(date[0])} - ${toDateFormat(date[1])})`
    }

    const handleExpandButtonClick = (event: any) => {
        onExpandButtonClick?.(event)
    }

    const handleCollapseButtonClick =(event: any) => {
        onCollapseButtonClick?.(event)
    }

    const renderButton = () => {
        if (expanded){
            return (
                <CollapseButton 
                    onClick={handleCollapseButtonClick}
                />
            )
        }

        return (
            <ExpandButton 
                onClick={handleExpandButtonClick}
            />
        )
    }

    return (
        <div className={styles.ChartHeader}>
            <div className={styles.ChartHeader__StartContainer}>
                <div>
                    <div className={styles.ChartHeader__Name}>
                        {name}
                    </div>
                </div>
                <div>
                    <div className={styles.ChartHeader__Date}>
                        {dateString}
                    </div>
                </div>
            </div>
            <div className={styles.ChartHeader__EndContainer}>
                <div>
                    {renderButton()}  
                </div>
           
            </div>
        </div>
    )
}